"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.TextMap = exports.IconMap = void 0;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _icons = require("@ant-design/icons");
var _antd = require("antd");
var _classnames = _interopRequireDefault(require("classnames"));
var _useMergedState3 = _interopRequireDefault(require("rc-util/es/hooks/useMergedState"));
var _react = _interopRequireDefault(require("react"));
var _icons2 = require("../../icons");
var _makeStyle = _interopRequireDefault(require("../../utils/makeStyle"));
var _statistic = require("../../utils/statistic");
var _tokenItem = _interopRequireDefault(require("../token-item"));
var Panel = _antd.Collapse.Panel;
var IconMap = exports.IconMap = {
  seed: /*#__PURE__*/_react.default.createElement(_icons.BulbOutlined, null),
  colorText: /*#__PURE__*/_react.default.createElement(_icons.FontColorsOutlined, null),
  colorBg: /*#__PURE__*/_react.default.createElement(_icons.BgColorsOutlined, null),
  colorSplit: /*#__PURE__*/_react.default.createElement(_icons.BorderHorizontalOutlined, null),
  colorFill: /*#__PURE__*/_react.default.createElement(_icons.HighlightOutlined, null),
  colorCommon: /*#__PURE__*/_react.default.createElement(_icons.FormatPainterOutlined, null),
  space: /*#__PURE__*/_react.default.createElement(_icons2.ShapeLine, null),
  font: /*#__PURE__*/_react.default.createElement(_icons.FontSizeOutlined, null),
  line: /*#__PURE__*/_react.default.createElement(_icons.AlignLeftOutlined, null),
  screen: /*#__PURE__*/_react.default.createElement(_icons.TabletOutlined, null),
  motion: /*#__PURE__*/_react.default.createElement(_icons2.Motion, null),
  radius: /*#__PURE__*/_react.default.createElement(_icons.RadiusSettingOutlined, null),
  control: /*#__PURE__*/_react.default.createElement(_icons.ControlOutlined, null),
  others: /*#__PURE__*/_react.default.createElement(_icons.FileUnknownOutlined, null)
};
var TextMap = exports.TextMap = {
  seed: 'Seed Token',
  colorCommon: 'Common Color 通用颜色',
  colorText: 'Text Color 文本颜色',
  colorBg: 'Background Color 背景颜色',
  colorFill: 'Fill Color 填充颜色',
  colorSplit: 'Split Color 分割线颜色',
  space: 'Space 间距',
  font: 'Font 文本',
  line: 'Line 线',
  screen: 'Screen 屏幕',
  motion: 'Motion 动画',
  radius: 'Radius 圆角',
  control: 'Control 控件',
  others: 'Others 未分类'
};
var useStyle = (0, _makeStyle.default)('TokenCard', function (token) {
  return (0, _defineProperty2.default)({
    '.token-card': (0, _defineProperty2.default)({
      width: '100%',
      height: 'auto',
      borderRadius: token.borderRadiusLG,
      border: "1px solid rgba(0,0,0,0.09)",
      marginBottom: token.marginSM
    }, "".concat(token.rootCls, "-collapse.token-card-collapse"), (0, _defineProperty2.default)({}, "> ".concat(token.rootCls, "-collapse-item > ").concat(token.rootCls, "-collapse-content > ").concat(token.rootCls, "-collapse-content-box"), {
      padding: {
        _skip_check_: true,
        value: "0 ".concat(token.paddingXS, "px 12px !important")
      }
    }))
  }, ".token-card ".concat(token.rootCls, "-input-group >").concat(token.rootCls, "-input:not(:first-child):not(:last-child)"), {
    background: 'white',
    borderRadius: token.borderRadiusLG
  });
});
var _default = exports.default = function _default(_ref2) {
  var title = _ref2.title,
    icon = _ref2.icon,
    tokenArr = _ref2.tokenArr,
    keyword = _ref2.keyword,
    hideUseless = _ref2.hideUseless,
    defaultOpen = _ref2.defaultOpen,
    customOpen = _ref2.open,
    onOpenChange = _ref2.onOpenChange,
    activeToken = _ref2.activeToken,
    onActiveTokenChange = _ref2.onActiveTokenChange,
    onTokenChange = _ref2.onTokenChange,
    tokenPath = _ref2.tokenPath,
    selectedTokens = _ref2.selectedTokens,
    themes = _ref2.themes,
    onTokenSelect = _ref2.onTokenSelect,
    enableTokenSelect = _ref2.enableTokenSelect,
    hideUsageCount = _ref2.hideUsageCount,
    fallback = _ref2.fallback,
    placeholder = _ref2.placeholder;
  var _useStyle = useStyle(),
    _useStyle2 = (0, _slicedToArray2.default)(_useStyle, 2),
    wrapSSR = _useStyle2[0],
    hashId = _useStyle2[1];
  var _useMergedState = (0, _useMergedState3.default)(false, {
      onChange: onOpenChange,
      defaultValue: defaultOpen,
      value: customOpen
    }),
    _useMergedState2 = (0, _slicedToArray2.default)(_useMergedState, 2),
    open = _useMergedState2[0],
    setOpen = _useMergedState2[1];
  return wrapSSR( /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)('token-card', hashId)
  }, /*#__PURE__*/_react.default.createElement(_antd.Collapse, {
    ghost: true,
    expandIcon: function expandIcon(_ref3) {
      var isActive = _ref3.isActive;
      return /*#__PURE__*/_react.default.createElement(_icons.CaretRightOutlined, {
        rotate: isActive ? 450 : 360,
        style: {
          fontSize: 12,
          color: 'rgba(0,0,0,0.45)'
        }
      });
    },
    expandIconPosition: "right",
    className: "token-card-collapse",
    activeKey: open ? '1' : undefined,
    onChange: function onChange(keys) {
      // onOpenChange?.(keys.length > 0);
      setOpen(keys.length > 0);
    }
  }, /*#__PURE__*/_react.default.createElement(Panel, {
    header: /*#__PURE__*/_react.default.createElement(_antd.Space, {
      size: "small"
    }, /*#__PURE__*/_react.default.createElement("span", null, title), /*#__PURE__*/_react.default.createElement("span", null, icon)),
    key: "1"
  }, tokenArr.filter(function (tokenName) {
    return (!keyword || tokenName.toLowerCase().includes(keyword.toLowerCase())) && (!hideUseless || (0, _statistic.getRelatedComponents)(tokenName).length > 0);
  }).map(function (tokenName) {
    return /*#__PURE__*/_react.default.createElement(_tokenItem.default, {
      tokenPath: tokenPath,
      onActiveChange: function onActiveChange(active) {
        return onActiveTokenChange === null || onActiveTokenChange === void 0 ? void 0 : onActiveTokenChange(active ? tokenName : undefined);
      },
      active: activeToken === tokenName,
      tokenName: tokenName,
      key: tokenName,
      onTokenChange: onTokenChange,
      themes: themes,
      selectedTokens: selectedTokens,
      onTokenSelect: onTokenSelect,
      enableTokenSelect: enableTokenSelect,
      hideUsageCount: hideUsageCount,
      fallback: fallback
    });
  }), tokenArr.length === 0 && placeholder))));
};